function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Wind"
}, /*#__PURE__*/React.createElement("title", null, "VF_wind_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M234.6 168.6l12.7-25.4-70-35v-1.9c0-18-8.8-28.9-21.4-33.2V0h-28.3v73.1c-12.6 4.4-21.4 15.3-21.4 33.2v1.9l-70 35 12.7 25.4 68.9-34.4c2.9 2.3 6.3 4.2 9.8 5.4v143.9H156v-144c3.6-1.2 6.9-3 9.8-5.3l68.8 34.4zm-92.7-48.3c-7.7 0-14-4.4-14-14s6.3-14 14-14 14 4.4 14 14-6.2 14-14 14z"
}))));